export default __webpack_public_path__ + "static/media/Nose_4.391cf03c.svg";